import cn from '@repo/shared/utils/cn';
import type React from 'react';
import { Fragment } from 'react';

type ActiveBorderProps = {
	optionHeight: number;

	/** Callback or ref object for the top border element */
	itemRef?: React.Ref<HTMLDivElement>;
};
export function ActiveBorder({ optionHeight, itemRef }: ActiveBorderProps) {
	const className = cn(
		'from-selection-solid/0 to-selection-solid/0 via-selection-solid/60 bg-gradient-to-r h-px w-full absolute top-1/2',
	);
	const renderBorder = (
		multiplier: number,
		itemRef?: React.Ref<HTMLDivElement>,
	) => {
		const offset = (multiplier * optionHeight) / 2;
		return (
			<div
				className={className}
				style={{ transform: `translateY(${offset}px)` }}
				ref={itemRef}
			/>
		);
	};
	return (
		<Fragment>
			{renderBorder(-1, itemRef)}
			{renderBorder(1)}
		</Fragment>
	);
}
